const isProd = process.env.BUILD_ENV === "prod";
const adjustRelativeUrl = `https://${isProd ? "" : "test-"}eur-device.altracking.net/device/ad_ids_report`;

// 注册：2；登录成功：3
export enum RelativeType {
  Register = 2,
  Login = 3,
}

export type RelativeCustomParamsType = {
  country_id: string;
  device_id: string;
  uid: string;
  web_uuid: string;
};

export async function reportAdjustRelative(
  type: RelativeType,
  attribution: Adjust.Attribution & RelativeCustomParamsType
): Promise<void> {
  try {
    fetch(adjustRelativeUrl, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        adjust_id: attribution.adid,
        web_uuid: attribution.web_uuid || "",
        uid: attribution.uid || "",
        country_id: attribution.country_id || "",
        device_id: attribution.device_id || "",
        type: type,
        platform: "2",
        app_brand: "silvrr_web",
        os_type: "web",
        tracker_name: attribution.tracker_name || "",
        network: attribution.network || "",
        campaign: attribution.campaign || "",
        adgroup: attribution.adgroup || "",
        creative: attribution.creative || "",
        click_label: attribution.click_label || "",
        create_time: Date.now(),
        ad_id: "",
        serial_no: "",
        device_base: "",
      }),
    });
  } catch (error) {
    // console.error("sk--", error);
  }
}
